import React from 'react';
import T from 'prop-types';
import { useNavigate } from 'react-router-dom';
// components
import Typography from 'components/Typography';
// icons
import { ReactComponent as ChevronIcon } from 'icons/chevron.svg';
// styles
import classnames from 'classnames/bind';
import styles from './Breadcrumbs.module.scss';

const cx = classnames.bind(styles);

const Breadcrumbs = ({ crumbs = {}, className }) => {
  const navigate = useNavigate();

  return (
    <div className={cx('wrapper', className)}>
      {Object.entries(crumbs).map(([name, link], idx) => (
        <div key={`${name}-${idx}`} className={cx('crumb-wrapper')}>
          <ChevronIcon className={cx('separator')} />
          <Typography className={cx('crumb', 'mgh-5')} type="body-xs" onClick={() => navigate(link)}>
            {name}
          </Typography>
        </div>
      ))}
    </div>
  );
};

Breadcrumbs.propTypes = {
  crumbs: T.object,
  className: T.string,
};

export default Breadcrumbs;
